/*------------------------------------*\
    PASTE WARNING
\*------------------------------------*/
const translate = require('../../site/_data/i18n');

// Get locale from URL
const pathArray = window.location.pathname.split('/');
const locale = pathArray[1];

class PasteWarning {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.elem.addEventListener('paste', evt => {
            alert(translate.partials.pasteWarning[locale]);
        });
    }
}

export default PasteWarning;
